import {
  StoryblokServerComponent,
  storyblokEditable,
} from '@storyblok/react/rsc';
import { FC } from 'react';
import type { PageStoryblok } from 'storyblok-types';

export const Page: FC<{ blok: PageStoryblok }> = ({ blok }) => (
  <div className="page" {...storyblokEditable(blok)}>
    {blok?.body?.map((nestedBlok) => (
      <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
    ))}
  </div>
);
